import { render } from "./hr-step-card.vue?vue&type=template&id=c6c1f87c&scoped=true"
import script from "./hr-step-card.vue?vue&type=script&lang=js"
export * from "./hr-step-card.vue?vue&type=script&lang=js"

import "./hr-step-card.vue?vue&type=style&index=0&id=c6c1f87c&scoped=true&lang=scss"

import exportComponent from "/home/jenkins/workspace/DeputyApp_web-hr_202604021339/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c1f87c"]])

export default __exports__